const HUIPlugin = {
  install(Vue) {
    // $confirm封装，对话框方式的弹窗
    Vue.prototype.$error = function (msg) {
      //todo 把插件方法加到弹窗的beforeOpen和close事件
      return this.$msgbox({
        title: this.$t('error'),
        type: 'error',
        message: msg,
        confirmButtonText: this.$t('close')
      });
    };

    Vue.prototype.$info = function (msg) {
      return this.$msgbox({
        title: this.$t('hint'),
        type: 'info',
        confirmButtonText: this.$t('close'),
        message: msg
      });
    };

    Vue.prototype.$waring = function (msg) {
      return this.$msgbox({
        title: this.$t('warning'),
        confirmButtonText: this.$t('close'),
        message: msg,
        type: 'warning'
      });
    };

    Vue.prototype.$question = function (msg) {
      return this.$confirm(msg, {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'question'
      });
    };
    Vue.prototype.$configuration = function (msg) {
      return this.$confirm(msg, {
        confirmButtonText: this.$t('configuration'),
        cancelButtonText: this.$t('cancel'),
        type: 'info'
      });
    };

    // $message封装，屏幕上方滚下的的弹框
    Vue.prototype.$successMsg = function (msg = this.$t('msg_success')) {
      return this.$message({
        message: msg,
        type: 'success'
      });
    };

    Vue.prototype.$warningMsg = function (msg) {
      return this.$message({
        message: msg,
        type: 'warning'
      });
    };

    Vue.prototype.$infoMsg = function (msg) {
      return this.$message({
        message: msg,
        type: 'info'
      });
    };

    Vue.prototype.$errorMsg = function (msg = this.$t('error_1203')) {
      return this.$message({
        message: msg,
        type: 'error',
        duration: 6000,
        showClose: true
      });
    };
  }
};

export default HUIPlugin;
